document.addEventListener('DOMContentLoaded', function () {
    function formatDiscountedPrice(originalText, discountPercent) {
        const decimalSeparator = originalText.includes(',') ? ',' : '.';
        const numericString = originalText.replace(/[^0-9,\.]/g, '').replace(',', '.');
        const originalPrice = parseFloat(numericString);

        if (isNaN(originalPrice)) return null;

        const newPrice = (originalPrice * ((100 - discountPercent) / 100)).toFixed(2);
        const newFormattedNumber = newPrice.replace('.', decimalSeparator);

        return originalText.replace(/[0-9]+(?:[,.][0-9]+)?/, newFormattedNumber);
    }

    function switchProductDiscountImage(discountPercent) {
        const discountKey = String(discountPercent);
        const imageSource = document.querySelector('.product__media-list');
        if (!imageSource) return;

        const utmData = imageSource.dataset.utm;
        if (!utmData) return;

        const images = JSON.parse(utmData);
        const match = images.find(({ src }) => src.includes(discountKey));
        if (!match) return;

        const featuredImage = document.querySelector('.product__media-list img');
        featuredImage.src = match.src;
        featuredImage.srcset = match.srcset;
    }

    if (activeDiscounts.length>0 && activeDiscounts[0].percent) {
        console.log("[Discount Apply] Active code:", activeDiscounts[0].name, "| Discount:", activeDiscounts[0].percent + "%");

        switchProductDiscountImage(activeDiscounts[0].percent);
        // If no Compare Prices
        const basicPrices = document.querySelectorAll('.price__regular .price-item--regular');

        // If Compare Prices exist
        const comparePrices = document.querySelectorAll('.price__sale .price-item--regular');
        const salePrices = document.querySelectorAll('.price__sale .price-item--sale');
  
        comparePrices.forEach((comparePriceEl, index) => {
            let originalText = comparePriceEl.textContent.trim();
            // First scenario with Compare and Sale Prices 
            if (originalText!="") {
                const newFormatted = formatDiscountedPrice(originalText, activeDiscounts[0].percent);

                if (newFormatted && salePrices[index]) {
                    salePrices[index].textContent = newFormatted;
                }
            }
            // 2nd scenario without Compare Prices 
            else{
                let originalText = basicPrices[index].textContent.trim();
                const newFormatted = formatDiscountedPrice(originalText, activeDiscounts[0].percent);

                if (newFormatted && comparePrices[index] && salePrices[index]) {
                   comparePrices[index].textContent = originalText;
                   salePrices[index].textContent = newFormatted;
                   salePrices[index].parentElement.style.display = "block";
                   salePrices[index].closest('.price').classList.add('price--on-sale');
                }
            }
        });
    } else {
        console.log("[Discount Apply] No Price Element or valid product discount code found.");
    }


    // Readjust Badges with XX% Off
    document.querySelectorAll('.card-wrapper.product-card-wrapper').forEach((card) => {
        const regularPriceEl = card.querySelector('.price__sale .price-item--regular');
        const salePriceEl = card.querySelector('.price__sale .price-item--sale');
        const badgeEl = card.querySelector('.card__badge');
        const badgeTextEl = card.querySelector('.card__badge .badge');

        if (!regularPriceEl || !salePriceEl || !badgeEl || !badgeTextEl) return;

        const regularPrice = parseFloat(regularPriceEl.textContent.replace(/[^0-9,\.]/g, '').replace(',', '.'));
        const salePrice = parseFloat(salePriceEl.textContent.replace(/[^0-9,\.]/g, '').replace(',', '.'));

        if (!regularPrice || !salePrice || regularPrice <= salePrice) return;

        badgeTextEl.textContent = Math.round(((regularPrice - salePrice) / regularPrice) * 100) + '% Off';
        badgeEl.classList.add('is-visible');
    });
});
